import React, { useState } from "react";
import { Option } from "react-bootstrap-typeahead/types/types";
import moment from "moment";
import { StyledSubTitle } from "../../../styles/MainStyles";
import S from "../../../styles/pages/HistoryTach/TachHistoryFilters";
import ButtonStyles from "../../../styles/components/ButtonStyles";
import Autocomplete from "../../../components/Autocomplete";
import { useTachHistory } from "../../../context/TachContext/TachHistoryContext";

const { BtnPrimary, BtnOutlinePrimary } = ButtonStyles;

type DateRange = [Date, Date];
type YearOption = {
    label: string;
    value: string;
};

const TachHistoryFilters: React.FC = () => {
    const [selectedYear, setSelectedYear] = useState<Option[]>([
        new Date(),
        new Date(),
    ]);
    const {
        filterDocuments,
        selectedTeacher,
        years,
        getTachDocuments,
        yearValue,
        setYearValue,
        dateRange,
        setDateRange,
    } = useTachHistory();

    const handleValidateDateRange = () => {
        return dateRange[0] && dateRange[1];
    };

    const handleChangeDate = () => {
        if (!handleValidateDateRange()) {
            setDateRange([dateRange[0], dateRange[0]]);
        }
    };

    const setFirstDayOfYear = (year: Option[]): Date => {
        return new Date(
            `01/01/${
                (
                    year[0] as {
                        value: string;
                        label: string;
                    }
                )?.value
            }`
        );
    };

    const setLastDayOfYear = (year: Option[]): Date => {
        return new Date(
            `12/31/${
                (
                    year[0] as {
                        value: string;
                        label: string;
                    }
                )?.value
            }`
        );
    };

    const currentYear: Option[] = [
        {
            label: new Date().getFullYear().toString(),
            value: new Date().getFullYear().toString(),
        },
    ];

    const setCurrentYearForSelectDate = (year: Option[]): DateRange => {
        const hasSelectedYear = year.length > 0;
        const normalizedYear = hasSelectedYear ? year : currentYear;

        return [
            setFirstDayOfYear(normalizedYear),
            setLastDayOfYear(normalizedYear),
        ] as unknown as DateRange;
    };

    const handleAutocompleteChange = (selected: Option[]) => {
        setYearValue(selected);
        setSelectedYear(selected);
        setDateRange(setCurrentYearForSelectDate(selected));
    };

    const momentDate = (date: any) => moment(date).format("YYYY-MM-DD");

    const handleFilterDocuments = async () => {
        const teacherId = (selectedTeacher[0] as any)?.value;
        const year = (selectedYear[0] as any)?.value;

        const filteredData = {
            teacherId,
            initialDate: momentDate(dateRange[0]),
            finalDate: momentDate(dateRange[1]),
            year,
        };

        getTachDocuments(filteredData);

        filterDocuments(
            dateRange[0].getFullYear().toString(),
            selectedYear.length === 0
                ? ""
                : (selectedYear[0] as unknown as YearOption).value
        );
    };

    const choosenYear = years.map((year) => ({
        label: year.toString(),
        value: year.toString(),
    })) as Option[];

    const cleaningFilters = () => {
        setYearValue([]);
        setDateRange([new Date(), new Date()]);
        const teacherId = (selectedTeacher[0] as any)?.value;
        getTachDocuments({ teacherId });
    };

    return (
        <S.TachHistoryFiltersContainer>
            <StyledSubTitle>
                Utilize os filtros abaixo para facilitar sua busca
            </StyledSubTitle>
            <S.TachHistoryFilters>
                <Autocomplete
                    style={S.TachHistoryYearAutocompleteStyles}
                    onChange={(selected: Option[]) => {
                        handleAutocompleteChange(selected);
                    }}
                    selected={yearValue}
                    options={choosenYear}
                    placeholder="Selecione o ano"
                />
                <S.TachHistoryStyledCalendar
                    selectionMode="range"
                    value={dateRange}
                    dateFormat="dd/mm/yy"
                    onHide={handleChangeDate}
                    onChange={(e) => {
                        setDateRange(e.value as DateRange);
                    }}
                    minDate={setFirstDayOfYear(selectedYear) as unknown as Date}
                    maxDate={setLastDayOfYear(selectedYear) as unknown as Date}
                />
                <S.TachHistoryButtonsContainer>
                    <BtnPrimary
                        onClick={() => handleFilterDocuments()}
                        disabled={selectedTeacher.length === 0}
                    >
                        Filtrar
                    </BtnPrimary>
                    <BtnOutlinePrimary onClick={() => cleaningFilters()}>
                        Limpar
                    </BtnOutlinePrimary>
                </S.TachHistoryButtonsContainer>
            </S.TachHistoryFilters>
        </S.TachHistoryFiltersContainer>
    );
};

export { TachHistoryFilters };
